import EditApplicantAssetsAndLiabilities from './EditApplicantAssetsAndLiabilities';
import EditApplicantContactDetails from './EditApplicantContactDetails';
import EditApplicantCurrentAddress from './EditApplicantCurrentAddress';
import EditApplicantCurrentEmployments from './EditApplicantCurrentEmployments';
import EditApplicantLandlordDetails from './EditApplicantLandlordDetails';
import EditApplicantLivingExpenses from './EditApplicantLivingExpenses';
import EditApplicantOtherIncomes from './EditApplicantOtherIncomes';
import EditApplicantPreviousAddresses from './EditApplicantPreviousAddresses';
import EditApplicantPreviousEmployments from './EditApplicantPreviousEmployments';
import EditApplicantPrivacyConsent from './EditApplicantPrivacyConsent';
import EditApplicantCreditReport from './EditApplicantCreditReport';
import EditApplicantCreditReportContent from './EditApplicantCreditReportContent';
import EditApplicantReferences from './EditApplicantReferences';
import EditApplicantSpousesDetails from './EditApplicantSpousesDetails';
import EditApplicantVedaReport from './EditApplicantVedaReport';
import EditApplicantBankStatementReport from './EditApplicantBankStatementReport';
import EditApplicantDocumentRequests from './EditApplicantDocumentRequests';
import EditLoanAsset from './EditLoanAsset';
import EditLoanComments from './EditLoanComments';
import EditLoanDetails from './EditLoanDetails';
import EditLoanCurrentSubmission from './EditLoanCurrentSubmission';
import EditLoanPreviousSubmissions from './EditLoanPreviousSubmissions';
import EditLoanInsurances from './EditLoanInsurances';
import EditSuitabilityAssessment from './EditSuitabilityAssessment.vue';

export default {
    EditApplicantAssetsAndLiabilities,
    EditApplicantContactDetails,
    EditApplicantCurrentAddress,
    EditApplicantCurrentEmployments,
    EditApplicantLandlordDetails,
    EditApplicantLivingExpenses,
    EditApplicantOtherIncomes,
    EditApplicantPreviousAddresses,
    EditApplicantPreviousEmployments,
    EditApplicantPrivacyConsent,
    EditApplicantCreditReport,
    EditApplicantCreditReportContent,
    EditApplicantReferences,
    EditApplicantSpousesDetails,
    EditApplicantVedaReport,
    EditApplicantBankStatementReport,
    EditApplicantDocumentRequests,
    EditLoanAsset,
    EditLoanComments,
    EditLoanDetails,
    EditLoanCurrentSubmission,
    EditLoanPreviousSubmissions,
    EditLoanInsurances,
    EditSuitabilityAssessment,
};
